export default __webpack_public_path__ + "afcc67e203faffcf33267fb131cbe741.png";